import React from "react";

export const Edit: React.FC<{}> = () => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>z. Icons/Edit</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group">
        <rect id="Rectangle" x="0" y="0" width="40" height="40" />
        <path
          d="M15,33.75 L7.5,33.75 C6.80964406,33.75 6.25,33.1903559 6.25,32.5 L6.25,25.517767 C6.25,25.1862462 6.38169625,24.8683034 6.61611719,24.6338828 L25.3661172,5.88388281 C25.8542724,5.39572833 26.6457276,5.39572833 27.1338828,5.88388281 L34.1161172,12.8661172 C34.6042717,13.3542724 34.6042717,14.1457276 34.1161172,14.6338828 L15,33.75 Z"
          id="Path"
          stroke="#252525"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="21.25"
          y1="10"
          x2="30"
          y2="18.75"
          id="Path"
          stroke="#252525"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="15"
          y1="33.75"
          x2="6.32953125"
          y2="25.0795312"
          id="Path"
          stroke="#252525"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default {};
